module.exports = __webpack_public_path__ + "images/emails/info/logo-postmark-a8f426dd.png";